import React from "react";
import {
  Plus,
  Search,
  Briefcase,
  Users,
  FileText,
  TrendingUp,
  ArrowRight,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const QuickActions: React.FC = () => {
  const navigate = useNavigate();

  const actions = [
    {
      icon: Plus,
      title: "프로필 만들기",
      description: "전문적인 프로필을 만들어보세요",
      action: () => navigate("/profile/me"),
      color: "bg-blue-500 hover:bg-blue-600",
      textColor: "text-blue-600",
    },
    {
      icon: Search,
      title: "인재 검색",
      description: "우수한 인재를 찾아보세요",
      action: () => navigate("/search"),
      color: "bg-green-500 hover:bg-green-600",
      textColor: "text-green-600",
    },
    {
      icon: Briefcase,
      title: "채용공고 등록",
      description: "회사의 채용공고를 등록하세요",
      action: () => navigate("/jobs"),
      color: "bg-purple-500 hover:bg-purple-600",
      textColor: "text-purple-600",
    },
    {
      icon: FileText,
      title: "이력서 업로드",
      description: "PDF 이력서를 업로드하세요",
      action: () => navigate("/profile/me"),
      color: "bg-orange-500 hover:bg-orange-600",
      textColor: "text-orange-600",
    },
  ];

  const quickStats = [
    { label: "오늘의 신규 채용공고", value: "24개", icon: TrendingUp },
    { label: "이번 주 신규 프로필", value: "156개", icon: Users },
    { label: "성공 매칭", value: "89건", icon: Briefcase },
  ];

  return (
    <div className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            빠른 시작하기
          </h2>
          <p className="text-xl text-gray-600">
            몇 번의 클릭으로 채용 플랫폼을 시작하세요
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {actions.map((action, index) => (
            <div
              key={index}
              onClick={action.action}
              className="group cursor-pointer bg-white rounded-xl p-6 border border-gray-200 hover:shadow-lg hover:border-gray-300 transition-all"
            >
              <div
                className={`inline-flex items-center justify-center w-12 h-12 ${action.color} rounded-lg mb-4 group-hover:scale-110 transition-transform`}
              >
                <action.icon className="w-6 h-6 text-white" />
              </div>

              <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                {action.title}
              </h3>

              <p className="text-gray-600 text-sm mb-4">{action.description}</p>

              <div className="flex items-center text-sm font-medium group-hover:text-blue-600 transition-colors">
                <span>시작하기</span>
                <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          ))}
        </div>

        {/* 빠른 통계 */}
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-8">
            실시간 플랫폼 현황
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {quickStats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full mb-4 shadow-sm">
                  <stat.icon className="w-8 h-8 text-blue-600" />
                </div>
                <div className="text-3xl font-bold text-gray-900 mb-2">
                  {stat.value}
                </div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;
